import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PAGE } from "../constants/page";
import ModalLoader from "./ModalLoader";
import { useAuth } from "react-oidc-context";
import jwt_decode from "jwt-decode";
import { OIDC_CONFIG } from "../utility/Keycloak";
import Utility from "../utility/Utility";
import { API } from "../constants/api";
import { ApiCallWithLoader, errorUpdate } from "../redux/reducers/LoaderSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { ROLE } from "../constants/role";
import { updateUser, UserState } from "../redux/reducers/UserSlice";
import {
  updateStateId,
  updateStateList,
} from "../redux/reducers/PractionerRoleIdsSlice";
import { stateLanguageList } from "../constants/options";
import { useTranslation } from "react-i18next";
import BreadcrumbService from "../services/BreadcrumbsService";
import { PersistState, updateLanguage } from "../redux/reducers/PersistSlice";
import AuthService from "src/services/AuthService";
import { applyStateLevelConfig } from "src/redux/reducers/UserConfigSlice";

const GlobalHome = () => {
  const navigation = useNavigate();
  const userDetails: any = useAppSelector(UserState);
  const userLanguageSelected: any = useAppSelector(PersistState);
  const keycloak = useAuth();
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const breadcrumbService = BreadcrumbService.instance;
  const languageCookie = Utility.getCookie("KEYCLOAK_LOCALE");

  let previousData = {
    email: "",
    userRegion: "",
  };

  const gotoGlobalAdmin = async () => {
    try {
      const requestDetails = {
        url: API.STATES,
        method: "GET",
      };
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      dispatch(updateStateList(resp.payload?.entry));
      const routeLinkGlobalAdmin = PAGE.GLOBAL_STATE_ADMIN.replace(
        ":state",
        resp.payload?.entry[0].resource.name
      ).concat("/admin");
      dispatch(updateStateId(resp?.payload?.entry[0]?.resource?.id));
      navigation(routeLinkGlobalAdmin);
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const userNavigation = async (userType: string, email: string) => {
    try {
      const requestDetails = {
        url: API.GET_USER_DETAILS,
        method: "POST",
        callType: "auth0",
        requestData: {
          userId: AuthService.instance?.user?.auth0_id,
        },
      };

      const userResp = await dispatch(ApiCallWithLoader(requestDetails));
      const userStateName =
        userResp?.payload?.user_metadata?.address?.region || "";
      const getStateLanguage = stateLanguageList.find(data => {
        return data.stateName.toLowerCase() === userStateName.toLowerCase();
      });
      dispatch(applyStateLevelConfig(userStateName));
      dispatch(updateUser({ ...userResp?.payload }));
      let storingData = {
        email: userResp?.payload?.email,
        userRegion: userResp?.payload?.user_metadata?.address?.region,
      };
      localStorage.setItem("userData", JSON.stringify(storingData));

      switch (userType) {
        case ROLE.GLOBAL_ADMIN:
        case ROLE.GLOBAL_ADMIN_SUPPORT:
          gotoGlobalAdmin();
          if (
            userDetails?.isInitialPageLoad &&
            userLanguageSelected?.language === ""
          ) {
            i18n.changeLanguage("en");
            dispatch(updateLanguage("en"));
          }
          break;
        case ROLE.ADMIN:
          const routeLink = PAGE.STATE_ADMIN;
          navigation(routeLink.concat("/asha"));
          if (
            userDetails?.isInitialPageLoad &&
            userLanguageSelected?.language == ""
          ) {
            i18n.changeLanguage("en");
            dispatch(updateLanguage("en"));
          }
          break;
        case ROLE.ASHA:
        case ROLE.ANM:
        case "screen-patients":
        case "manage-patients":
          if (
            previousData.email !== userResp?.payload?.email &&
            (userLanguageSelected?.language === "" ||
              userLanguageSelected?.language !== getStateLanguage?.value)
          ) {
            localStorage.setItem("userData", JSON.stringify(storingData));
            if (getStateLanguage) {
              const userCountryConfig = Utility.getUserCountryConfig(
                userLanguageSelected?.country
              );
              // Checking if the state language belongs to the country
              if (
                languageCookie == undefined && 
                userCountryConfig?.available_languages.includes(
                  getStateLanguage.value
                )
              ) {
                i18n.changeLanguage(getStateLanguage.value);
                dispatch(updateLanguage(getStateLanguage.value));
              }
            }
          }
          breadcrumbService.active_key = "";
          navigation(PAGE.HOME);
          break;
        default:
          console.log("Do Nothing");
      }
    } catch (error) {}
  };

  useEffect(() => {
    setTimeout(() => {
      if (keycloak) {
        const token_value: any = jwt_decode(
          keycloak["user"]?.access_token || ""
        );
        const userType =
          token_value && token_value?.resource_access[OIDC_CONFIG.client_id]
            ? token_value?.resource_access[OIDC_CONFIG.client_id]["roles"][0]
            : "";
        userNavigation(userType || "", keycloak?.user?.profile.email || "");
      }
    }, 300);
  }, []);
  useEffect(() => {
    let getLocalData = JSON.parse(localStorage.getItem("userData") || "{}");
    previousData.email = getLocalData.email;
    previousData.userRegion = getLocalData.userRegion;
  }, [JSON.parse(localStorage.getItem("userData") || "{}")]);

  return (
    <>
      <ModalLoader />
    </>
  );
};

export default GlobalHome;
